import { useState } from "react";

export const useHandleChangeEvent = (initialValue?: any) => {
  const [getter, setter] = useState(initialValue);
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setter(event.target.value);
  };
  return [getter, handleChange];
};
